import React, { Component } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themesAnimated from '@amcharts/amcharts4/themes/animated';
import * as am4plugins_sliceGrouper from "@amcharts/amcharts4/plugins/sliceGrouper"; 

import _ from 'lodash';
import * as MD from '@material-ui/core';
import { TypedStorage } from '../../Utils/TypedStorage';
import { History } from 'history';
import { ILocaleInfos, I18N } from '../../Store/I18n/Types';
import am4lang_en_US from "@amcharts/amcharts4/lang/en_US";
import am4lang_fr_FR from "@amcharts/amcharts4/lang/fr_FR";
import { IData1, IStatsFilters1, IStatsState } from '../../Store/Statistics/Types';
import { convertColor, decimalToRgb } from '../../Utils/Various';
import { IApplicationState } from '../../Store';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getStatisticsStep1 } from '../../Store/Statistics/Actions';

const styles = (theme:any) => MD.createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
      clear:'both',
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    toggleDiv:{
      width:'100%',
    },
    thStyle: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary
    },
    legendWrapper: {
        maxHeight: '600px',
        overflowX: 'hidden',
        overflowY: 'auto',
    },
    tableContainer: {
        width: '30%',
        border: '1px solid rgb(190, 190, 190)',
        maxHeight: '600px',
        height: 'fit-content'
    },
    tableRightBorder: { 
        borderRightWidth: 1, 
        borderRightStyle: 'groove',
    },
    tabNames: {
        backgroundColor: 'gray',
        marginTop: 10,
        fontWeight: 500,
        color: theme.palette.text.primary,
        padding: 10,
        display: 'inline-flex'
    },
    active: {
        color: '#7863e0',
        fill: '#7863e0'
    },
    text: {
        fill: 'white'
    },
    stepper: {
        marginTop: 10,
        marginBottom: 10,
        paddingTop: 10,
        paddingBottom: 5,
        width: '99%'
    }
  });

  interface IPropsFromState {
    i18n: I18N;
    localeInfos: ILocaleInfos;
    stats: IStatsState;
}
  
interface IPropsFromDispatch {
    getStatisticsStep1: typeof getStatisticsStep1
}
  
interface IOwnProps {
    chartId: string,
    data: any[],
    category: string,
    title: string,
    titleColor: string | undefined,
    chartName: string,
    value: string,
    history: History,
    buildStepper: () => void
}

interface IPieState {
    showPercent: boolean,
    showPRHD: boolean,
    data: any,
    initialData: any
}
const initialState: IPieState = {
    showPercent: true,
    showPRHD: true,
    data: null,
    initialData: null
}

type PieAllProps = 
    MD.WithTheme &
    MD.WithStyles<typeof styles> &
    IPropsFromState &
    IPropsFromDispatch &
    IOwnProps;


export class PieChartComponent extends Component<PieAllProps, IPieState> {

    chart: any;
    public constructor(props: PieAllProps) {
        super(props);
        this.state = {...initialState};
    }

    static getDerivedStateFromProps(props: PieAllProps, state: IPieState) {
       if (props.data !== null && state.data === null) {
           state.data = props.data
           state.initialData = props.data
       }
       if (props.stats.statsFilters1?.show_pres !== state.showPRHD && props.stats.statsFilters1?.show_pres !== undefined) {
           state.showPRHD = props.stats.statsFilters1?.show_pres
       }
        return state
    }

    componentDidMount() {
        this.initChart(this.props, this.state);
    }

    componentDidUpdate(prevProps: PieAllProps, prevState:IPieState) {
        //Handle refreshing the chart when the dataset changes
        if (!_.isEqual(prevProps.data, this.props.data) || !_.isEqual(prevProps.localeInfos.momentLocale, this.props.localeInfos.momentLocale)) {
            if (this.chart) {
                if (this.props.chartId === 'chart3') {
                    let charts = am4core.registry.baseSprites
                    if (charts !== null && charts.length > 1 ) {
                        if (charts[1].svgContainer !== undefined && charts[1].svgContainer.htmlElement.id === 'chart4') {
                            charts[1].dispose()
                        }
                    }
                }
                this.chart.dispose();
            }
            this.initChart(this.props, this.state);
        }
        if (!_.isEqual(prevState.showPercent, this.state.showPercent) || !_.isEqual(prevState.showPRHD, this.state.showPRHD)) {
            this.chart.dispose();
            this.initChart(this.props, this.state);
        }
        if (!_.isEqual(prevProps.theme, this.props.theme)) {
            this.chart.dispose();
            this.initChart(this.props, this.state);
        }
    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    initChart(props:PieAllProps, state:IPieState) {
        //All of our work goes here now
        const { chartId, i18n, localeInfos, history, category, theme } = this.props; 
        const { data } = this.state
        am4core.useTheme(am4themesAnimated);
        // Create chart instance
        let chart = am4core.create(chartId, am4charts.PieChart);
        if (localeInfos.momentLocale === "en-us"){
            chart.language.locale = am4lang_en_US;
        } else if (localeInfos.momentLocale === "fr") {
            chart.language.locale = am4lang_fr_FR
        }
        // Add data
        let newData = !this.state.showPRHD ? 
        data.filter((x:any) => x.political_regime_name !== 'PRES REP HORS DEBAT') : data
        chart.data = newData;
        chart.logo.hidden = true
        chart.logo.height = -15000
        // Let's cut a hole in our Pie chart the size of 20% the radius
        chart.innerRadius = am4core.percent(20);
        // Add and configure Series
        let pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = props.value;
        pieSeries.dataFields.category = props.category;
        
        let title = chart.titles.create();
        let topContainer = chart.chartContainer.createChild(am4core.Container);
        //let axisTitle:any = topContainer.createChild(am4core.Label);
        let dateTitle:any = topContainer.createChild(am4core.Label);
        var container:any = new am4core.Container() as any;
        var label:any = new am4core.Label();

        if (props.chartId === 'chartGroup') {
            title.text = 'Autres < 1%';
            title.fill = am4core.color('white')
            title.hide();

            topContainer.layout = "absolute";
            topContainer.toBack();
            topContainer.paddingBottom = 15;
            topContainer.width = am4core.percent(100);

            //label.parent = container;
            container.parent = pieSeries;
            container.horizontalCenter = "middle";
            container.verticalCenter = "middle";
            //container.width = am4core.percent(40) / Math.sqrt(2);
            container.fill = "white";

            label.parent = container;
            label.text = "Autres < 1%";
            label.fontWeight = 500;
            label.align = "left";
            label.paddingLeft = 10;
            label.fill = am4core.color(props.theme.palette.primary.main);
            label.horizontalCenter = "middle";
            label.verticalCenter = "middle";
            label.fontSize = 18;
            label.hide();

            dateTitle.text = "Revenir à l'ensemble des données";
            dateTitle.fontWeight = 500;
            dateTitle.align = "right";
            dateTitle.paddingRight = 100;
            dateTitle.fill = am4core.color(props.theme.palette.primary.main);
            dateTitle.hide();
        }

        pieSeries.slices.template.events.on("hit", function(ev) {
            if (ev.target) {
                let slice:any = ev.target.slice
                if (slice) {
                    let data = slice.dataItem.dataContext as any
                    if (data.political_group_name !== 'Autres < 1%') {
                        if (data.political_regime_id || data.isRegimeActive) {
                            TypedStorage.set('politicalRegimeId', data.political_regime_id)
                            TypedStorage.set('politicalRegimeName', data[category])
                            TypedStorage.set('politicalRegimeColor', data.color)
                        }
                        if ((data.political_group_id || data.isGroupActive) && data.political_group_name !== 'Autres < 1%') {
                            TypedStorage.set('politicalGroupId', data.political_group_id)
                            TypedStorage.set('politicalGroupName', data[category])
                            TypedStorage.set('politicalGroupColor', data.color)
                        }
                        if (data.media_id || data.isMediaActive) {
                            TypedStorage.set('mediaId', data.media_id)
                            TypedStorage.set('mediaName', data[category])
                        }
                        history.push('/statistics')
                    }
                    else {
                        dateTitle.show()
                        label.show()
                    }
                }
            }
        })
        
        pieSeries.slices.template.events.on("ready", function(ev) {
            if (ev.target.dataItem) {
                let series = ev.target.dataItem.component as any;
                if (series && series.slices) {
                    series.slices.each(function(item:any) {
                        let data:any = item.dataItem.dataContext
                        if ( props.chartId === 'chartRegime' && data.political_regime_name === props.stats.regimeName) {
                            item.isActive = true
                        } 
                        else if ( props.chartId === 'chartGroup' && data.political_group_name === props.stats.groupName) {
                            item.isActive = true
                        }
                        else if ( props.chartId === 'chartMedia' && data.media_name === props.stats.mediaName) {
                            item.isActive = true
                        }
                        else {
                            item.isActive = false
                        }
                    })
                }
            }
        })
        /* Disable labels */
        if (pieSeries.ticks.template !== undefined) {
            pieSeries.ticks.template.disabled = !state.showPercent;
            pieSeries.labels.template.disabled = !state.showPercent;
        }

        /* group slices that are lower than 0.5 percent */ 
        
        if (props.chartId === 'chartGroup' && data.length > 14) {
            var grouper:am4plugins_sliceGrouper.SliceGrouper = pieSeries.plugins.push(new am4plugins_sliceGrouper.SliceGrouper());
            grouper.clickBehavior = "zoom";
            grouper.threshold = 1;
            grouper.groupName = 'Autres < 1%'
            let properties:any = grouper.groupProperties;
            properties.cursorOverStyle = am4core.MouseCursorStyle.pointer;
            if (grouper.zoomOutButton.icon !== undefined) {
                grouper.zoomOutButton.icon.disabled = true
            }
            var zoomImage = grouper.zoomOutButton.createChild(am4core.Image);
            zoomImage.href = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDk2IDk2IiBoZWlnaHQ9Ijk2cHgiIGlkPSJ6b29tX291dCIgdmVyc2lvbj0iMS4xIiB2aWV3Qm94PSIwIDAgOTYgOTYiIHdpZHRoPSI5NnB4IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48cGF0aCBkPSJNOTAuODI5LDg1LjE3MUw2OC4xMjEsNjIuNDY0QzczLjA0Nyw1Ni4zMDcsNzYsNDguNSw3Niw0MEM3NiwyMC4xMTgsNTkuODgyLDQsNDAsNEMyMC4xMTgsNCw0LDIwLjExOCw0LDQwczE2LjExOCwzNiwzNiwzNiAgYzguNSwwLDE2LjMwNi0yLjk1MywyMi40NjQtNy44NzlsMjIuNzA4LDIyLjcwOGMxLjU2MiwxLjU2Miw0LjA5NSwxLjU2Miw1LjY1NywwQzkyLjM5MSw4OS4yNjcsOTIuMzkxLDg2LjczMyw5MC44MjksODUuMTcxeiAgIE00MCw2OGMtMTUuNDY0LDAtMjgtMTIuNTM2LTI4LTI4czEyLjUzNi0yOCwyOC0yOGMxNS40NjQsMCwyOCwxMi41MzYsMjgsMjhTNTUuNDY0LDY4LDQwLDY4eiIvPjxwYXRoIGQ9Ik01Niw0MGMwLDIuMjA5LTEuNzkxLDQtNCw0SDI4Yy0yLjIwOSwwLTQtMS43OTEtNC00bDAsMGMwLTIuMjA5LDEuNzkxLTQsNC00aDI0QzU0LjIwOSwzNiw1NiwzNy43OTEsNTYsNDBMNTYsNDB6Ii8+PC9zdmc+";
            zoomImage.width = 30;
            zoomImage.height = 30;
            grouper.zoomOutButton.background.fill = am4core.color(props.theme.palette.primary.main)
            grouper.zoomOutButton.marginRight = 30;
            zoomImage.interactionsEnabled = false;
            grouper.zoomOutButton.events.on("hit", (ev:any) => {
                dateTitle.hide()
                label.hide()
            })
        }
        
        /* Change labels text */ 
        pieSeries.labels.template.adapter.add("text", (label, target, key) => {
            if (target.dataItem ) {
                let data:any = target.dataItem.dataContext;
                if (data.political_group_name === 'Autres < 1%' && props.chartId === 'chartGroup') {
                    return `Autres < 1%: (${data.percent.toPrecision(2)} %)`
                } else {
                    return (
                        this.state.showPRHD ? `${data[category]} (${data.percent})\n${i18n._('duration')}: ${data.duration}\n`:
                        `${data[category]} (${data.percent})`
                    )
                 }
                } else {
              return label;
            }
        });
          
        pieSeries.labels.template.fill = am4core.color(theme.palette.text.primary);
        pieSeries.labels.template.fontSize = 10
        pieSeries.labels.template.paddingTop = 0;

        /* color ticks */
        pieSeries.ticks.template.adapter.add('fill', (fill, target:any)=> {
            return am4core.color(theme.palette.text.primary);
        })
        pieSeries.ticks.template.fill = am4core.color(theme.palette.text.primary);

        /* Decorate axis tooltip content */
        pieSeries.slices.template.adapter.add('tooltipText', (text, target: any) => {
            if (target.dataItem) {
                let data:any = target.dataItem.dataContext;
                let name:any = data[category] 
                let duration:string = data.duration;
                if (data.political_group_name === 'Autres < 1%' && props.chartId === 'chartGroup') {
                    return `Autres < 1%:\n${data.percent.toPrecision(2)}%`
                } else {
                   return (
                       `${name}\n${data.percent}\n${i18n._('duration')}: [bold]${duration}\n`
                   )
                }
            } else return text
        });
        /* color slices */
        pieSeries.slices.template.adapter.add('fill', (fill, target:any)=> {
            if (target.dataItem) {
                let data:IData1 = target.dataItem.dataContext;
                if (data.color) {
                    let color:any = data.color;
                    color = decimalToRgb(color)
                    return am4core.color(`rgb(${color.red},${color.green},${color.blue})`)
                }
            } else return fill
        })

        this.chart = chart;
    }

    private buildTitle() {
        const { theme } = this.props;
        
        return(
            <div style={{display: 'block', width: '60%'}}>
                <span>
                    {`Répartition par ${this.props.chartName}`} {this.props.stats.periodTitle !== undefined && this.props.stats.periodTitle !== '' && `(${this.props.stats.periodTitle})`}
                </span>
                <div style={{textTransform: 'capitalize', marginTop: '10px'}}>
                        <span style={{
                            backgroundColor: this.props.chartId !== 'chartMedia' ? this.props.titleColor : undefined,
                            padding: '10px',
                            color: this.props.chartId === 'chartMedia' ? theme.palette.primary.main : theme.palette.primary.light
                            }}
                        >
                            {this.props.title}
                        </span>
                </div>
            </div>
        )
    }
  
    private handleShowPercent() {
        this.setState({ showPercent: !this.state.showPercent})  
    }
  
    private handleShowRepReg() {
        let newShowPRD = !this.state.showPRHD
        let filters = this.props.stats.statsFilters1 as IStatsFilters1
        this.props.getStatisticsStep1({
            ...filters,
            show_pres: newShowPRD
        }, this.props.stats.periodTitle)

        this.setState({
            showPRHD: newShowPRD,
        })
    }
    private buildDisplayFormat() {
        const { theme } = this.props;
        return (
            <div >
                <div id="showPercent" style={{display: 'inline-flex', position: 'absolute'}}>
                    <MD.Checkbox
                    style={{color: this.state.showPercent ? theme.palette.primary.main : theme.palette.primary.light }}
                    value={this.state.showPercent}
                    checked={this.state.showPercent}
                    onClick= { ()=> this.handleShowPercent() }
                    />
                    <MD.ListItemText primary={"Afficher les pourcentages"} />
                </div>
                <div id="showPRHD" style={{display: 'inline-flex', position: 'absolute', marginTop: '25px'}}>
                <MD.Checkbox
                color='primary'
                value={this.state.showPRHD}
                checked={this.state.showPRHD}
                onClick= { ()=> this.handleShowRepReg() }
                />
                <MD.ListItemText primary={"Président République Hors Débat"} />
            </div>
            </div>
        )
    }
    private onMouseOver(event:React.MouseEvent<HTMLTableRowElement|SVGSVGElement, MouseEvent>, row:any){
        event.stopPropagation()
        let pieSeries = this.chart.series.values[0]
        let slices = pieSeries.slices.values
        if (slices) {
            slices.map((slice:any) => {
                let dataItem = slice.dataItem
                if (dataItem) {
                    let data = dataItem.dataContext
                    if ( this.props.chartId === 'chartRegime' && data.political_regime_id === row.political_regime_id) {
                        slice.isActive = true
                        slice.dataItem.dataContext = {
                            ...slice.dataItem.dataContext,
                            isRegimeActive: true,
                            isGroupActive: false,
                            isMediaActive: false
                        }
                    } 
                    else if ( this.props.chartId === 'chartGroup' && data.political_group_id === row.political_group_id) {
                        slice.isActive = true
                        slice.dataItem.dataContext = {
                            ...slice.dataItem.dataContext,
                            isRegimeActive: false,
                            isGroupActive: true,
                            isMediaActive: false
                        }
                    }
                    else if ( this.props.chartId === 'chartMedia' && data.media_id === row.media_id) {
                        slice.isActive = true
                        slice.dataItem.dataContext = {
                            ...slice.dataItem.dataContext,
                            isRegimeActive: false,
                            isGroupActive: false,
                            isMediaActive: true
                        }
                    }
                    else {
                        slice.isActive = false
                        slice.dataItem.dataContext = {
                            ...slice.dataItem.dataContext,
                            isRegimeActive: false,
                            isGroupActive: false,
                            isMediaActive: false
                        }
                    }
                }
                return slice
            })
        }
    }
    private handleClick(event:React.MouseEvent<HTMLTableRowElement|SVGSVGElement, MouseEvent>, data:any){
        event.stopPropagation()
        if (data.political_regime_id) {
            TypedStorage.set('politicalRegimeId', data.political_regime_id)
            TypedStorage.set('politicalRegimeName', data.political_regime_name)
            TypedStorage.set('politicalRegimeColor', data.color)
        }
        if (data.political_group_id) {
            TypedStorage.set('politicalGroupId', data.political_group_id)
            TypedStorage.set('politicalGroupName', data.political_group_name)
            TypedStorage.set('politicalGroupColor', data.color)
        }
        if (data.media_id) {
            TypedStorage.set('mediaId', data.media_id)
            TypedStorage.set('mediaName', data.media_name)
        }
        this.props.history.push('/statistics')
    }
    
    private buildLegend(data:any[]) {
        const { classes, i18n, chartName, theme} = this.props;
        return (
            <MD.TableContainer className={classes.tableContainer}>
                <MD.Table aria-label="simple table">
                    <MD.TableHead>
                        <MD.TableRow>
                        <MD.TableCell 
                        style={{
                            backgroundColor: theme.palette.background.paper,
                            color: theme.palette.text.secondary,
                            textTransform: 'capitalize'
                        }} 
                        className={classes.tableRightBorder}
                        > 
                            {chartName} 
                        </MD.TableCell>
                        <MD.TableCell 
                            className={classes.thStyle} 
                            style={{
                                    textAlign: 'center', textTransform: 'capitalize',borderRightWidth: 1, 
                                    borderRightStyle: 'groove',
                                }}
                        >{i18n._('duration')}
                        </MD.TableCell>
                        <MD.TableCell 
                            className={classes.thStyle} 
                            style={{
                                    textAlign: 'center', textTransform: 'capitalize',borderRightWidth: 1, 
                                    borderRightStyle: 'groove',
                                }}
                        >{i18n._('pourcentage')}
                        </MD.TableCell>
                        { data[0].percents_100 !== undefined && <MD.TableCell 
                            className={classes.thStyle} 
                            style={{
                                    textAlign: 'center', textTransform: 'capitalize',borderRightWidth: 1, 
                                    borderRightStyle: 'groove',
                                }}
                        >{i18n._('pourcentage base 100')}
                        </MD.TableCell>
                        }
                        </MD.TableRow>
                    </MD.TableHead>
                    <MD.TableBody>
                    {data.map((row:any, index:number) => (
                        <MD.TableRow 
                        hover={true}
                        key={index}
                        style={{cursor: 'pointer'}}
                        onClick={(event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => this.handleClick(event, row)}
                        onMouseOver={(event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => this.onMouseOver(event, row)}
                        >
                            <MD.TableCell 
                            className={classes.tableRightBorder} 
                            component="th" 
                            scope="row"
                            >
                                <div style={{display: 'inline-flex'}}>
                                   { this.props.chartId !== 'chartMedia' &&  
                                    <span 
                                        style={{
                                            display: "block",
                                            marginRight: "3px",
                                            width: "25px",
                                            height: "25px",
                                            textAlign: "center",
                                            border: "solid 1px #888",
                                            borderRadius: '4px',
                                            fontWeight:500,
                                            backgroundColor: convertColor(row.color)
                                        }}
                                        ></span>
                                    }
                                    <span style={{padding: this.props.chartId !== 'chartMedia' ? '5px' : '0px', fontWeight: 400}}>
                                        {row.political_regime_name || row.political_group_name || row.media_name}
                                    </span>
                                </div>
                            </MD.TableCell>
                            <MD.TableCell style={{
                                textAlign: 'center', fontWeight: 400
                            }}
                            className={classes.tableRightBorder} 
                            >
                                {row.duration}
                            </MD.TableCell>
                            <MD.TableCell style={{
                                textAlign: 'center', fontWeight: 400
                            }}
                            className={classes.tableRightBorder} 
                            >
                                {row.percent} 
                            </MD.TableCell>
                            {row.percents_100 !== undefined && <MD.TableCell style={{
                                textAlign: 'center', fontWeight: 400
                            }}
                            className={classes.tableRightBorder} 
                            >
                                {row.percents_100} 
                            </MD.TableCell>}
                        </MD.TableRow>
                    ))}
                    </MD.TableBody>
                </MD.Table>
            </MD.TableContainer>
        )
    }
    
    render() {
        return (
            <div style={{ display: 'inline-flex', width: '100%'}}>
                <div style={{width: '70%'}}>
                    <div style={{display: 'inline-flex', width: '100%'}}>
                        { this.buildTitle() }
                        { this.buildDisplayFormat() }
                    </div>
                    { this.props.buildStepper() }
                    {/* <MD.Divider style={{marginTop: '20px', width: '98%'}} /> */}
                    <div id={this.props.chartId} style={{ width: "100%", height: "500px" }} />
                </div>
                {this.state.data !== null && this.state.data.length > 0 && this.buildLegend(this.state.data) }
            </div>
        )
    }
}
const mapStateToProps = ( { i18n, ui, stats } : IApplicationState) => ({
    localeInfos: i18n.localeInfos,
    i18n: i18n.i18n,
    ui,
    stats
  });
  
  const mapDispatchToProps = (dispatch: Dispatch) => ({
    getStatisticsStep1: (filters: IStatsFilters1, periodTitle?: string) => dispatch(getStatisticsStep1(filters, periodTitle)),
  });
  
export const PieChart = connect( mapStateToProps, mapDispatchToProps)
(MD.withTheme(MD.withStyles(styles)(PieChartComponent)));
